import { compareDatesAsc } from './dateUtils';

// ============================================================================
// Interfaces using ISO strings
// ============================================================================

interface SortableEntryByString {
  order: string | null | undefined;
}

interface SortableMeasurementByString {
  timestamp: string | null | undefined;
}

/**
 * Sort entries by order field (ascending).
 * Works with ISO string dates.
 */
export const entryOrderSortByString = (a: SortableEntryByString, b: SortableEntryByString): number => {
  return compareDatesAsc(a.order, b.order);
};

/**
 * Sort measurements by timestamp field (ascending).
 * Works with ISO string dates.
 */
export const measurementTimestampSortByString = (a: SortableMeasurementByString, b: SortableMeasurementByString): number => {
  return compareDatesAsc(a.timestamp, b.timestamp);
};
